import React from 'react';
import * as styles from './List.module.scss';

type Props = {
  children: React.ReactNode;
  className?: string;
};

export const ListItem = ({ children, className }: Props) => {
  const classes = [styles.listItem];

  if (className) classes.push(className);

  return <li className={classes.join(' ')}>{children}</li>;
};
